import React from 'react'
import Image from '../../../images/sellerpolicies/1.png'

const Account_suspension_penalties = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Account Suspension & Penalties</h2>
            <p>Offenses that can lead to SUSPENSION, DOWN GRADATION, PENALTIES, OR PERMANENT SUSPENSION of the seller shop include, but are not limited to, the following:</p>
            <ul>
                <li>a.	High rate of return on products</li>
                <li>b.	Lack of respect for packaging guidelines</li>
                <li>c.	Cancellations and orders out of stock</li>
                <li>d.	Slow fulfillment of orders</li>
                <li>e.	Selling counterfeit and illegal Products</li>
            </ul>
        </div>
      </div>
    </div>
  )
}

export default Account_suspension_penalties
